export interface TaxRates {
  rateId: string;
  type: TaxType;
  taxAuthority: TaxAuthorityData;
  descriptions: Description[];
  isIncluded: boolean;
  startDateTime: string;
  endDateTime: string;
  rateCondition: RateConditionData;
  calculationMethod: TaxCalculationMethodData;
  dependenceRates: string[];
  roundingMethod: RoundingMethod;
  isCouponReduceTaxationAmount: boolean;
  taxableAmountRoundingStrategyKey: string;
}

interface TaxAuthorityData {
  authorityId: string;
  descriptions: Description[];
}

interface Description {
  culture: string;
  value: string;
}

interface RateConditionData {
  zoneId: string;
  products: Products[];
  categories: Categories[];
  groups: Groups[];
  minimumTaxableAmount: number;
  containEatInProducts: boolean;
  includeAccessorialFee: boolean;
}

interface Products {
  isExclude: boolean;
  itemCode: string;
}

interface Categories {
  categoryId: string;
  categoryLabel: string;
  isExclude: boolean;
}

interface Groups {
  groupId: string;
  isExclude: boolean;
}

interface TaxCalculationMethodData {
  calculationMethodType: CalculationMethodType;
  leveles: TieredLevel[];
}

interface TieredLevel {
  from: number;
  to: number;
  value: number;
  supportedImposition: SupportedImposition;
  BracketId: string;
}

interface SupportedImposition {
  impositionId: string;
  indicator: string;
}

export enum TaxType {
  Tax = 'Tax',
  ItemFee = 'ItemFee',
  TransactionFee = 'TransactionFee',
  Surcharge = 'Surcharge',
  AccessorialFee = 'AccessorialFee',
}

export enum CalculationMethodType {
  Percent = 'Percent',
  FixedAmount = 'FixedAmount',
  MultiLevelTiered = 'MultiLevelTiered',
  TopLevelTiered = 'TopLevelTiered',
  Volume = 'Volume',
  BracketsMultiTiered = 'BracketsMultiTiered',
  BracketsTopTiered = 'BracketsTopTiered',
  Brackets = 'Brackets',
}

export enum RoundingMethod {
  Standard = 'Standard',
  Up = 'Up',
  Down = 'Down',
  None = 'None',
}
